export default "__VITE_ASSET__3HmyqSbR__"